import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ProvidehttpService } from "./providehttp.service";
import { RetailStock } from "./retail-common.service";

@Injectable({
  providedIn: "root",
})
export class OnboardingService {
  isRegistration: boolean = false;
  draftData: any = {};
  currentStage: string = "personalDetails";
  completedStage: number = -1;
  doResume:boolean = false;
  phoneNumber:string = "";
  stages: any = [
    "personalDetails",
    "addressDetails",
    "TaxDetailsNew",
    "taxInfoDetails",
    "employeeDetails",
    "contactDetails",
  ];

  constructor(private http: ProvidehttpService, private router: Router, private retailStock:RetailStock) {}

  //this.services.onboarding.setDraftData('personalDetails', personalDetails);
  setDraftData(key, data) {
    this.draftData[key] = data;
    this.draftData["currentStage"] = key;
  }

  getDraftData() {
    this.draftData["deviceId"] = sessionStorage.getItem("deviceId");
    let jsonString = JSON.stringify(this.draftData);
    return jsonString;
  }

  updateDraftData(stage, data) {
    this.draftData[stage] = data;
  }

  saveAsDraft(callback:any=()=>{}) {
    let inputMap = new Map();
    inputMap.clear();
    inputMap.set("PathParam.draftType", "DT");
    inputMap.set("PathParam.userId", sessionStorage.getItem("deviceId"));
    inputMap.set("Body.userdraft.draftContent", this.getDraftData());
    this.http
      .fetchApi(
        "/userdraft/{userId}/{draftType}",
        "PUT",
        inputMap,
        this.retailStock.getEnvironment().commonPublisher
      )
      .subscribe(
        async (httpResponse: HttpResponse<any>) => {
          var res = httpResponse.body;
          callback();
        },
        async (httpError) => {
          var err = httpError["error"];
          if (
            err != null &&
            err["ErrorElementPath"] != undefined &&
            err["ErrorDescription"] != undefined
          ) {
          }
        }
      );
  }

  getNextStage() {
    let stage = "";
    if (this.draftData && this.draftData.currentStage) {
      let i = this.stages.indexOf(this.draftData.currentStage);
      this.completedStage = i;
      this.currentStage = this.stages[i + 1];
      stage = this.stages[i + 1];
      if (!stage) {
        this.phoneNumber = this.draftData.contactDetails.mobileNumber;
        this.currentStage = "cobSummary";
        stage = "cobSummary";
      }
    }
    return stage;
  }

  getPreviousStage(currentStage) {
    let stage = "";
    let i = this.stages.indexOf(currentStage);
    stage = this.stages[i - 1];
    if (i - 1 == -1) {
      stage = "country";
    }
    return stage;
  }

  gotoStage(stage) {
    this.router.navigate(["/onboarding/" + stage]);
  }

  getOnboardingDetails(callback:any = null) {
    //if(this.doResume) return false;
    //if(!this.doResume) this.draftData = {};
    this.currentStage = "personalDetails";
    this.completedStage = -1;
    let inputMap = new Map();
    inputMap.clear();
    inputMap.set("PathParam.userId", sessionStorage.getItem("deviceId"));
    inputMap.set("PathParam.draftType", "DT");
    this.http
      .fetchApi(
        "/userdraft/{userId}/{draftType}",
        "GET",
        inputMap,
        this.retailStock.getEnvironment().commonPublisher
      )
      .subscribe(
        async (httpResponse: HttpResponse<any>) => {
          var res = httpResponse.body;
          if (res) {
            this.draftData = JSON.parse(res["userdraft"]["draftContent"]);
            this.draftData["deviceId"] = sessionStorage.getItem("deviceId");
            this.currentStage = this.draftData.currentStage;

            let i = this.stages.indexOf(this.currentStage);
            this.completedStage = i;
            this.currentStage = this.getNextStage();

            if (this.currentStage != "country") {
              
              this.isRegistration = true;
              if(callback){
                callback(this.currentStage);
              } else {
                this.router.navigate(["/onboarding/" + this.currentStage]);
              }
            }
          }else{
            if(callback) callback(null);
          }
        },
        async (httpError) => {
          var err = httpError["error"];
          if (
            err != null &&
            err["ErrorElementPath"] != undefined &&
            err["ErrorDescription"] != undefined
          ) {
          }
          if(callback) callback(null);
        }
      );
  }

  setReadonlyFieldSet(fieldSetId, enable: boolean = true) {
    let fieldSetEl = document
      .getElementById(fieldSetId)
      .querySelector(".field-set");
    if (enable == true) {
      fieldSetEl.classList.add("read-only");
    } else {
      fieldSetEl.classList.remove("read-only");
    }
  }

  enableFieldSet(fieldSetId, enable: boolean = true) {
    let fieldSetEl = document
      .getElementById(fieldSetId)
      .querySelector(".field-set");
    if (enable == true) {
      fieldSetEl.classList.remove("preview-mode");
    } else {
      fieldSetEl.classList.add("preview-mode");
    }
  }

  storePIN(pin) {
    localStorage.setItem("pin", pin);
  }

  cancelRegistration() {
    this.router.navigate(["/welcome/appnavigator"]);
  }

  isDefaultPath() {
    return this.router.url == "/onboarding/chooseCountry";
  }
}
